import React, {Component} from 'react';
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import {NavLink} from "react-router-dom";
import GridListTileBar from "@material-ui/core/GridListTileBar";
import axios from "axios";
import Loader from "./Loader";


class Trending extends Component {
    state = {
        data: null,
        trending: '',
        location: '',
        loading: true

    };

    componentDidMount() {
        this.getTrends();
    }

    getTrends = () => {
        const location = JSON.parse(localStorage.getItem('location'));
        this.setState({location})
        let url = `${process.env.REACT_APP_BACKEND_URL}/item/trending`;
        if (!location)
            url = url + '?country=United Kingdom'
        if (location && location.city)
            url = url + '?city=' + location.city;

        axios.get(url)
            .then((res) => {
                this.setState({trending: res.data, loading: false});
            }).catch(err => console.error(err))
    }

    render() {
        const {trending, loading, location} = this.state;
        if (loading)
            return <Loader/>
        if (trending.length > 0)
            return (
                <div
                    style={{flex: 1}}
                    className="container-fluid py-4"
                    // className={classes.root}
                >
                    <h3>Trending {location && location.city ? <span>in <b>{location.city}</b></span> :
                        <span>in <b>United Kingdom</b></span>} </h3>
                    <hr/>
                    <GridList style={{flexWrap: 'nowrap'}} cols={2.5}>
                        {trending.map((item, index) => (
                            <GridListTile key={index}>
                                <img src={`${process.env.REACT_APP_BACKEND_URL}/uploads/${item.photo[0]}`}
                                     alt={item.title}/>
                                <NavLink
                                    to={`/${item.productId ? item.productId : item.category.toLowerCase() + '-' + (item.condition !== undefined ? item.condition.toLowerCase() : 'ads') + '-' + item.title.toLowerCase()}/item/${item._id}`}>
                                    <GridListTileBar
                                        title={item.title.toUpperCase()}
                                        subtitle={`£${item.price}`}
                                    />
                                </NavLink>
                            </GridListTile>
                        ))}
                        {trending.map((item, index) => (
                            <GridListTile key={index}>
                                <img src={`${process.env.REACT_APP_BACKEND_URL}/uploads/${item.photo[0]}`}
                                     alt={item.title}/>
                                <NavLink
                                    to={`/${item.productId ? item.productId : item.category.toLowerCase() + '-' + (item.condition !== undefined ? item.condition.toLowerCase() : 'ads') + '-' + item.title.toLowerCase()}/item/${item._id}`}>
                                    <GridListTileBar
                                        title={item.title.toUpperCase()}
                                        // classes={{
                                        //     // root: classes.titleBar,
                                        //     title: {color: 'white'},
                                        // }}
                                        // title
                                        // className={}
                                        subtitle={`£${item.price}`}
                                    />
                                </NavLink>
                            </GridListTile>
                        ))}
                        {trending.map((item, index) => (
                            <GridListTile key={index}>
                                <img src={`${process.env.REACT_APP_BACKEND_URL}/uploads/${item.photo[0]}`}
                                     alt={item.title}/>
                                <NavLink
                                    to={`/${item.productId ? item.productId : item.category.toLowerCase() + '-' + (item.condition !== undefined ? item.condition.toLowerCase() : 'ads') + '-' + item.title.toLowerCase()}/item/${item._id}`}>
                                    <GridListTileBar
                                        title={item.title.toUpperCase()}
                                        // classes={{
                                        //     // root: classes.titleBar,
                                        //     title: {color: 'white'},
                                        // }}
                                        // title
                                        // className={}
                                        subtitle={`£${item.price}`}
                                    />
                                </NavLink>
                            </GridListTile>
                        ))}
                        {trending.map((item, index) => (
                            <GridListTile key={index}>
                                <img src={`${process.env.REACT_APP_BACKEND_URL}/uploads/${item.photo[0]}`}
                                     alt={item.title}/>
                                <NavLink
                                    to={`/${item.productId ? item.productId : item.category.toLowerCase() + '-' + (item.condition !== undefined ? item.condition.toLowerCase() : 'ads') + '-' + item.title.toLowerCase()}/item/${item._id}`}>
                                    <GridListTileBar
                                        title={item.title.toUpperCase()}
                                        // classes={{
                                        //     // root: classes.titleBar,
                                        //     title: {color: 'white'},
                                        // }}
                                        // title
                                        // className={}
                                        subtitle={`£${item.price}`}
                                    />
                                </NavLink>
                            </GridListTile>
                        ))}
                        {trending.map((item, index) => (
                            <GridListTile key={index}>
                                <img src={`${process.env.REACT_APP_BACKEND_URL}/uploads/${item.photo[0]}`}
                                     alt={item.title}/>
                                <NavLink
                                    to={`/${item.productId ? item.productId : item.category.toLowerCase() + '-' + (item.condition !== undefined ? item.condition.toLowerCase() : 'ads') + '-' + item.title.toLowerCase()}/item/${item._id}`}>
                                    <GridListTileBar
                                        title={item.title.toUpperCase()}
                                        // classes={{
                                        //     // root: classes.titleBar,
                                        //     title: {color: 'white'},
                                        // }}
                                        // title
                                        // className={}
                                        subtitle={`£${item.price}`}
                                    />
                                </NavLink>
                            </GridListTile>
                        ))}
                        {trending.map((item, index) => (
                            <GridListTile key={index}>
                                <img src={`${process.env.REACT_APP_BACKEND_URL}/uploads/${item.photo[0]}`}
                                     alt={item.title}/>
                                <NavLink
                                    to={`/${item.productId ? item.productId : item.category.toLowerCase() + '-' + (item.condition !== undefined ? item.condition.toLowerCase() : 'ads') + '-' + item.title.toLowerCase()}/item/${item._id}`}>
                                    <GridListTileBar
                                        title={item.title.toUpperCase()}
                                        // classes={{
                                        //     // root: classes.titleBar,
                                        //     title: {color: 'white'},
                                        // }}
                                        // title
                                        // className={}
                                        subtitle={`£${item.price}`}
                                    />
                                </NavLink>
                            </GridListTile>
                        ))}
                    </GridList>
                </div>
            )
    }

}

export default Trending;



// WEBPACK FOOTER //
// ./src/components/Trending.js